import React from "react";
import { Shelf } from "./Shelf";

export const Bookshelf = () => <Shelf />;
